import React from 'react';

export default function Header() {
  return (
    <header className="site-header">
      <h1>Snowy Hydro - Snow depths</h1>
    </header>
  );
}
